<template>
  <div id="default-layout" :class="$route.name">
    <Popup :content="content" v-if="getPopup()" />
    <Bandeau />
    <div class="hide-on-mobile">
      <Header />
    </div>
    <MobileHeader class="hide-on-desktop" />
    <Sidebar />
    <div class="layout-content">
      <div class="loading" v-if="isLoading">
        <fai class="icon" icon="spinner" spin />
      </div>
      <slot></slot>
    </div>
    <CustomFooter />
    <Anchor />
  </div>
</template>

<script>
import Header from "@/components/Static/Header";
import MobileHeader from "@/components/Static/MobileHeader";
import CustomFooter from "@/components/Static/Footer";
import Anchor from "@/components/Static/Anchor";
import Sidebar from "@/components/Static/Sidebar";
import Bandeau from "@/components/Static/Bandeau";
import Popup from "@/components/Static/Popup";
import api from "@/api";

export default {
  components: {
    Header,
    CustomFooter,
    Sidebar,
    MobileHeader,
    Bandeau,
    Popup,
    Anchor,
  },
  data() {
    return {
      content: null,
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters.isLoading;
    },
  },
  methods: {
    openSidebar() {
      this.$store.commit("SET_SIDEBAR_STATUS", true);
    },
    getPopup() {
      if (this.$cookies.get("popupClosed")) {
        return false;
      }
      return this.$store.getters.popup;
    },
    scrollFix(hashbang) {
      location.href = hashbang;
    },
    closeResa(e) {
      if (e.target.id !== "cart" && e.target.parentNode.id !== "cart") {
        this.$store.commit("SET_RESA_STATUS", false);
      }
    },
    async fetchData() {
      const res = await api.get(`cdn/stories/${this.$i18n.locale}/popup`);
      this.content = res.data.story.content;

      this.$store.commit("SET_POPUP", res.data.story.content.display);
    },
  },
  mounted() {
    window.addEventListener("click", (e) => {
      this.closeResa(e);
    });
    this.fetchData();
  },
  destroyed() {
    window.removeEventListener("click", (e) => {
      this.closeResa(e);
    });
  },
};
</script>

<style lang="scss">
#default-layout {
  scroll-behavior: smooth;
}
.layout-content {
  min-height: 77vh;
  //background-color: #edefed;
  position: relative;
}
.loading {
  position: absolute;
  overflow: hidden;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  background-color: #edefed;
  z-index: 33;
  display: flex;
  justify-content: center;
  .icon {
    font-size: 70px;
    margin-top: calc(50vh - 50px);
    color: $primary;
  }
}
</style>